// extracted by mini-css-extract-plugin
export var container = "_2n-0";